/* eslint-disable no-undef */
/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// Import the main Tailwind file
import "animate.css";
import "./src/styles/global.css";

const OLD_PAGES_REDIRECT: Record<string, string> = {
  app: "/#application",
};

// Supported languages from gatsby-config
const LANGUAGES = ["fr"];

export const onClientEntry = () => {
  // Handle redirects for old pages
  const path = window.location.pathname;

  const langPattern = LANGUAGES.length > 0 ? `(${LANGUAGES.join("|")})\\/` : "";
  const pagesPattern = Object.keys(OLD_PAGES_REDIRECT).join("|");
  const redirectRegex = new RegExp(`^\\/(${langPattern})?(${pagesPattern})(\\/.*)?$`);

  const match = path.match(redirectRegex);
  if (match) {
    const detectedLang = match[2];
    const pageName = match[3];
    const targetAnchor = OLD_PAGES_REDIRECT[pageName] ?? "/";
    const basePath = detectedLang ? `/${detectedLang}` : "/";
    const targetPath = `${basePath}${targetAnchor}`;
    window.location.replace(targetPath);
  }
};
